
import React from 'react';
import { CardTitle, CardDescription, CardHeader } from '@/components/ui/card';
import { QrCode, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ScannerCardHeaderProps {
  onRefreshData?: () => void;
  isRefreshing: boolean;
}

const ScannerCardHeader = ({ onRefreshData, isRefreshing }: ScannerCardHeaderProps) => {
  const handleRefreshData = () => {
    if (!onRefreshData || isRefreshing) return;
    onRefreshData();
  };

  return (
    <CardHeader className="bg-gradient-to-r from-purple-100/70 to-indigo-100/40 dark:from-purple-900/50 dark:to-indigo-900/40 pb-4 border-b border-purple-100 dark:border-purple-900/30">
      <div className="flex justify-between items-start">
        <div>
          <CardTitle className="text-xl flex items-center gap-2 text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-indigo-600 dark:from-purple-400 dark:to-indigo-400">
            <QrCode size={20} className="text-indigo-600 dark:text-indigo-400" />
            Quét mã xác nhận
          </CardTitle>
          <CardDescription className="text-purple-700/80 dark:text-purple-300/80 font-medium">
            Quét mã QR hoặc nhập mã xác nhận (6 ký tự cuối) để tự động check-in
          </CardDescription>
        </div>
        {onRefreshData && (
          <Button 
            variant="ghost" 
            size="icon"
            onClick={handleRefreshData}
            disabled={isRefreshing}
            className="text-indigo-600 dark:text-indigo-400 hover:bg-indigo-100 dark:hover:bg-indigo-900/30 -mt-1"
          >
            <RefreshCw size={18} className={isRefreshing ? "animate-spin" : ""} />
          </Button>
        )}
      </div>
    </CardHeader>
  );
};

export default ScannerCardHeader;
